import { downloadFile, getFileInfo, getScrollHeight, getScrollTop, getWindowHeight } from "@/utils";
import { notEmpty, isEmpty, isFunction } from "@/utils/type";
import { footerHeight } from "@/assets/style/style.module.less";
import { htmlTextToText } from "@/utils";
export default {
  data() {
    return {
      debug: false,
      api: {
        list: null,
        details: null,
      },
      dataList: [],
      dataListLoading: false,
      fileKeys: ["icon"],
      // data数据中需要按照{url: ''}来处理的属性
      fileListKeys: ["attachFile"],
      idStr: this.$route.name || new Date().getTime() + "",
      noMore: false,
      listParams: {},
      pagination: {
        page: 1,
        sizeList: [5, 10, 20, 50, 100],
        size: 5,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      showDetails: false,
      isScrollLoad: false,
      scrollLoadLimit: parseInt(footerHeight) || 10,
      autoLoad: true,
      controller: null,
    };
  },
  methods: {
    notEmpty,
    isEmpty,
    downloadFile,
    htmlTextToText,
    /**
     * 滑动事件，判断是否触底
     */
    _scrollEvent() {
      let scrollTop = getScrollTop(),
        clientHeight = getWindowHeight(),
        scrollHeight = getScrollHeight();
      // console.log(
      //   scrollTop,
      //   clientHeight,
      //   this.scrollLoadLimit,
      //   scrollHeight,
      //   scrollTop + clientHeight + this.scrollLoadLimit >= scrollHeight
      // );
      // scrollLoadLimit 预判触底的阀值
      if (scrollTop + clientHeight + this.scrollLoadLimit >= scrollHeight) {
        this.debug &&
          console.log("[" + this.idStr + "] scrollEvent loading: " + this.dataListLoading + "; noMore: " + this.noMore);
        if (this.dataListLoading || this.noMore) return;
        this._getList();
      }
    },
    /**
     * 获取列表数据
     */
    _getList() {
      this.debug && console.log("loading: " + this.dataListLoading + "; noMore: " + this.noMore);
      // if (this.dataListLoading || (this.isScrollLoad && this.noMore)) return;
      if (this.isScrollLoad && this.noMore) return;
      if (this.controller) {
        this.controller.abort();
      }
      let { page, size } = this.pagination,
        params = {
          ...this.listParams,
          page,
          size,
          cancelBack: controller => {
            this.controller = controller;
          },
        };
      this.beforeGetList(params);
      this.debug && console.log("page: " + params.page + "; size: " + params.size);
      this.dataListLoading = true;
      this.api
        .list(params)
        .then(res => {
          if (res && res.data) {
            let data = res.data;
            this._checkFileJson(data.list);
            if (this.isScrollLoad) {
              this.dataList = [...this.dataList, ...data.list];
            } else {
              this.dataList = data.list;
            }
            this.pagination.page = data.current;
            this.pagination.total = parseInt(data.total);
            if (this.pagination.page * this.pagination.size >= this.pagination.total) {
              this.noMore = true;
            } else {
              this.noMore = false;
            }
            if (this.isScrollLoad) {
              this.pagination.page++;
            }
            this.afterGetDataList();
          } else {
            // this.$message.error('获取失败')
          }
        })
        .catch(error => {
          // this.$message.error('获取失败')
          console.error(error);
          this.noMore = true;
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    /**
     * 处理{url: ''}以jsonString存储的file数据
     */
    _checkFileJson(list) {
      if (isEmpty(this.fileListKeys) || isEmpty(list)) return;
      list.forEach(data => {
        getFileInfo(data, this.fileKeys, this.fileListKeys);
      });
      // console.log('_checkFileJson', list)
    },
    /**
     * 修改请求参数-实例可复写
     */
    beforeGetList(params) {},
    /**
     * 分页组件数据变更事件
     * @param {String} key 修改data.pagination[key]的数据
     * @param {Number} val
     * @param {Function} nextFun 修改后要执行的方法
     */
    _paginationChange(key, val, nextFun) {
      this.pagination[key] = val;
      if (key === "size") {
        this.pagination.page = 1;
      }
      try {
        nextFun && nextFun();
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 列表筛选点击事件
     * @param {String} key 修改data.listParams[key]的值
     * @param {String|Number|Boolean} val
     * @param {Function} nextFun 修改后要执行的方法
     * @param {Boolean} cancel 能否取消当前选项，默认可以取消
     */
    _clickTypeList(key, val, nextFun, cancel = true) {
      // 如果一开始就调用该方法会自动触发列表加载，就不应该再触发mounted里的自动加载
      this.autoLoad = false;
      this.debug && console.log("_clickTypeList ", key, val, !!nextFun, this.dataListLoading);
      // if (this.dataListLoading) return;
      this.debug && console.log("_clickTypeList 2", key, Object.prototype.hasOwnProperty.call(this.listParams, key));
      if (key && Object.prototype.hasOwnProperty.call(this.listParams, key)) {
        if (!cancel && this.listParams[key] == val) {
          return;
        }
        this.noMore = false;
        this.listParams[key] = this.listParams[key] == val ? "" : val;
        // 条件变更后自动刷新当前页为第一页
        this.pagination.page = 1;
        this.dataList = [];
        try {
          nextFun && nextFun();
        } catch (error) {
          console.error(error);
        }
      }
    },
    /**
     * 列表点击事件-打开DetailsPanel组件
     * @param {Object} params 该对象会混入listParams来请求, 且params权重更高
     */
    _openCotentPanel(params) {
      if (params && params.id) {
        this.$nextTick(() => {
          const tar = this.$refs["detailsPanel"];
          if (tar && tar.openCotentPanel) {
            tar.openCotentPanel(params);
          } else {
            console.warn("deatilsPanel不存在");
          }
        });
      } else {
        console.warn("没有传递id");
      }
    },
    /**
     * 打开/关闭 DetailsPanel组件
     * @param {Boolean} show
     */
    _changeDetailsPanelVisible(show) {
      this.showDetails = show;
    },
    /**
     * 页面滑动至指定id的元素
     * @param {String} id 元素id
     */
    _scrollTo(id) {
      try {
        var tar = document.querySelector("#" + id);
        // console.log(tar, window.scrollX, tar.offsetTop );
        window.scrollTo(window.scrollX, tar.offsetTop);
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 获取列表数据之后
     */
    afterGetDataList() {},
    /**
     * JSON string array
     * @param {string} str JSON
     * @returns array
     */
    getImageArr(str) {
      try {
        return JSON.parse(str);
      } catch (error) {
        return [];
      }
    },
    isLastData(index) {
      if (this.dataList?.length) {
        return index + 1 > this.pagination.size * (this.pagination.page - 2);
      }
      return false;
    },
  },
  mounted() {
    this.debug && console.log("ListMixin mounted autoLoad", this.autoLoad);
    if (this.autoLoad) {
      this._getList();
    }
    this.debug && console.log("isScrollLoad", this.isScrollLoad);
    if (this.isScrollLoad) {
      if (notEmpty(this.idStr)) {
        window._addScrollFun(this.idStr, this._scrollEvent);
      } else {
        console.error('not found "idStr"');
      }
    }
  },
  beforeDestroy() {
    if (this.isScrollLoad) {
      if (notEmpty(this.idStr)) {
        window._removeScrollFun(this.idStr);
      } else {
        console.error('not found "idStr"');
      }
    }
  },
};
